import React from "react";
import { SiteType } from "@/types";
import { SiteTableRow } from "@/components";
import { useSite } from "@/hooks";
import { useTranslations } from "next-intl";

type SiteTableProps = {
  data: SiteType[];
};

function SiteTable({ data }: Readonly<SiteTableProps>) {
  const t = useTranslations("site.SiteTable");
  const { site, setSite } = useSite();

  const handleClick = (newSite: SiteType) => {
    if (newSite !== site) setSite(newSite);
  };

  return (
    <table className="w-full text-sm">
      <thead>
        <tr className="m-0 p-0 even:bg-muted">
          <th className="w-[40%] px-4 py-3 text-left font-bold [&[align=center]]:text-center [&[align=right]]:text-right">
            {t("name")}
          </th>
          <th className="w-[20%] px-4 py-3 text-right font-bold [&[align=center]]:text-center [&[align=right]]:text-right">
            {t("latitude")}
          </th>
          <th className="w-[20%] px-4 py-3 text-right font-bold [&[align=center]]:text-center [&[align=right]]:text-right">
            {t("longitude")}
          </th>
          <th className="w-[20%] px-4 py-3 text-right font-bold [&[align=center]]:text-center [&[align=right]]:text-right">
            {t("altitude")}
          </th>
        </tr>
      </thead>
      <tbody>
        {!data.length && (
          <tr className="m-0 border-t p-0 text-sm">
            <td className="px-4 py-2 text-left" colSpan={5}>
              {t("notFound")}
            </td>
          </tr>
        )}
        {data.map((item) => (
          <SiteTableRow
            site={item}
            key={item.site_id}
            active={item.site_id == site?.site_id}
            onClick={() => handleClick(item)}
          />
        ))}
      </tbody>
    </table>
  );
}

export { SiteTable };
